// @flow
import React from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";
import Hidden from "@material-ui/core/Hidden";
import Grid from "@material-ui/core/Grid";
import { POSITION_SIDEBAR, POSITION_UNDER_HEADER } from "app/constants/ads";
import { TopBar } from "app/components/TopBar";
import { AdsBox } from "app/components/AdsBox";
import { WidgetTopNews } from "app/components/WidgetTopNews";
import { WidgetAuthors } from "app/components/WidgetAuthors";
import { WidgetReview } from "app/components/WidgetReview";
import { WidgetLatestMusics } from "app/components/WidgetLatestMusics";
import { WidgetLatestVideos } from "app/components/WidgetLatestVideos";
import { WidgetYektanet } from "app/components/WidgetYektanet";
import { SideNews } from "app/components/SideNews";
import { Quote } from "app/components/Quote";
import { Footer } from "app/components/Footer";
import styles from "./MainLayout.styles.js";

class MainLayout extends React.Component<Props> {
  componentDidUpdate(prevProps) {
    // if (prevProps.navigation.title !== this.props.navigation.title) {}
  }

  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <Helmet>
          <title>{this.props.navigation.meta.title || ""}</title>
          <meta
            name="description"
            content={this.props.navigation.meta.description}
          />
          <link
            rel="canonical"
            href={this.props.navigation.meta.canonicalUrl}
          />
          <link rel="next" href={this.props.navigation.meta.nextUrl} />
          <link rel="prev" href={this.props.navigation.meta.prevUrl} />
          <meta property="og:url" content={this.props.navigation.meta.ogUrl} />
          <meta
            property="og:title"
            content={
              this.props.navigation.meta.ogTitle ||
              this.props.navigation.meta.title
            }
          />
          <meta property="og:locale" content="fa_IR" />
          <meta
            property="og:type"
            content={this.props.navigation.meta.ogType}
          />
          <meta
            property="article:published_time"
            content={this.props.navigation.meta.ogArticlePublishedTime}
          />
          <meta
            property="article:section"
            content={this.props.navigation.meta.ogArticleSection}
          />
          <meta
            property="og:description"
            content={this.props.navigation.meta.ogDescription}
          />
          <meta property="og:url" content={this.props.navigation.meta.ogUrl} />
          <meta
            property="og:image"
            content={this.props.navigation.meta.ogImage}
          />
        </Helmet>

        <div id="layout-root" className={classes.root}>
          <SideNews />
          <div
            className={classNames(classes.wrapper, {
              [classes.hasSidebar]: this.props.sidebarIsOpen
            })}
          >
            <div className={classes.container}>
              <TopBar />
              <div className={classes.pageWrapper}>
                <Hidden only="xs">
                  <Grid container spacing={0}>
                    <Grid item xs={12} lg={12}>
                      <AdsBox
                        position={POSITION_UNDER_HEADER}
                        className={classes.topAds}
                      />
                    </Grid>
                  </Grid>
                </Hidden>

                <Grid container spacing={16}>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={9}
                    lg={9}
                    className={classes.contentWrapper}
                  >
                    <Quote />
                    <main className={classes.main}>{this.props.children}</main>
                  </Grid>

                  <Grid item xs={12} sm={12} md={3} lg={3}>
                    <AdsBox
                      position={this.props.sideAdsPosition || POSITION_SIDEBAR}
                    />
                    <WidgetYektanet method="banner" idNumber="4846" />
                    <WidgetTopNews list={this.props.sidebarTopNews} />
                    <WidgetAuthors />
                    <WidgetReview />
                    <WidgetLatestMusics />
                    <WidgetLatestVideos />
                  </Grid>
                </Grid>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  navigation: state.navigation,
  sidebarTopNews: state.sidebarTopNews,
  sidebarIsOpen: state.sidebarToggle === "open"
});

const Component = connect(mapStateToProps)(
  withStyles(styles, {
    withTheme: true
  })(MainLayout)
);
export { Component as MainLayout };

export default Component;
